import { MutationOptions, useMutation } from "react-query";
import { API_URL } from "../api";
import { APIError, APIResponse, post } from "../api";
import { FlightSearchData } from "../@types";

export interface SearchFlightsPayload {
  journeyType: "OneWay" | "Return" | "Circle";
  class: "Economy" | "Business" | "PremiumEconomy" | "First";
  departureDate: string; // Format: YYYY-MM-DD
  airlineCode?: string;
  airportOriginCode: string;
  airportDestinationCode: string;
  infants: number;
  adults: number;
  children: number;
}

function useSearchFlights(
  options?: MutationOptions<
    APIResponse<FlightSearchData>,
    APIError,
    SearchFlightsPayload
  >
) {
  const {
    isLoading: searchingFlights,
    isError: isSearchError,
    error: searchError,
    mutate: searchFlights,
    data: searchResult,
  } = useMutation<
    APIResponse<FlightSearchData>,
    APIError,
    SearchFlightsPayload
  >((variables: SearchFlightsPayload) => {
    return post(API_URL + "/aviation/international/search", variables, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
  }, options);

  return {
    searchFlights,
    searchResult,
    searchError,
    isSearchError,
    searchingFlights,
  };
}

export default useSearchFlights;
